import { toast } from "react-toastify";
import axiosWithToken from "./axiosTokenConfig";
import { BASE_URL } from "../../global";
import { fetchQuery } from "./fetched";

export const submitSiteDelete = async (table, id) => {
  const confirmed = window.confirm("Are you sure you want to delete this ?");
  if (!confirmed) return;

  const url = BASE_URL;
  try {
    const idArray = Array.isArray(id) ? id : [id];
    const idString = idArray.join(",");

    if (idArray.length == 1) {
      await axiosWithToken.patch(`${url}${table}/${idArray[0]}`, {status : -1});
    } else {
      
    let SQLQuery = `UPDATE ${table} SET status = -1 WHERE id IN (${idString})`;
      await fetchQuery(SQLQuery);
    }

    toast("Deleted Successfully!");
    setTimeout(() => window.location.reload(false), 1000);
  } catch (err) {
    console.error("Delete error:", err);
  }
};
